var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSourceStateError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9C17.995 4.03149 13.9685 0.00496107 9 0Z",
    fill: "#FFE4E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5C6.79086 5 5 6.79086 5 9C5 11.2091 6.79086 13 9 13C11.2091 13 13 11.2091 13 9C12.9978 6.79177 11.2082 5.0022 9 5Z",
    fill: "#F43F5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceStateError);
export default __webpack_public_path__ + "static/media/source-state-error.d5addcf59217bb5465d9bd9b373f49de.svg";
export { ForwardRef as ReactComponent };